export const GET_PROFILE = 'GET_PROFILE';
export const LOG_OUT = 'LOG_OUT';
export const ADD_LOCATION = 'ADD_LOCATION';
export const GET_PROFILE_FAILED = 'GET_PROFILE_FAILED';
export const EDIT_PROFILE_FIELD_STARTING = 'EDIT_PROFILE_FIELD_STARTING';
export const EDIT_PROFILE_FIELD = 'EDIT_PROFILE_FIELD';
export const CLEAR_STORES = 'CLEAR_STORES';
export const CLEAR_PROFILE_STORE = 'CLEAR_PROFILE_STORE';
export const REMOVE_LOCATION_STARTING = 'REMOVE_LOCATION_STARTING';
export const REMOVE_LOCATION_FAILED = 'REMOVE_LOCATION_FAILED';
export const REMOVE_LOCATION = 'REMOVE_LOCATION';
export const SEND_INVITATION_VIEWS = 'SEND_INVITATION_VIEWS';
export const PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
export const DELETE_COVER_IMAGE_FROM_PROFILE = 'DELETE_COVER_IMAGE_FROM_PROFILE';
export const UPDATE_SUPP_PROFILE_PROP = 'UPDATE_SUPP_PROFILE_PROP';
export const IMPORTING_LOC = '{profile}IMPORTING_LOC';
export const IMPORTED_LOC = '{profile}IMPORTED_LOC';

export const UPDATE_GROUP = '{profile} UPDATE_GROUP';
export const DELETE_GROUP = '{profile} DELETE_GROUP';

export const REORDER_LOCATIONS = '{profile} REORDER_LOCATIONS';
export const REORDER_PRODUCTS = '{profile} REORDER_PRODUCTS';



// WEBPACK FOOTER //
// ./src/app/stores/profile/company/profile-constants.js